











































































import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import * as service from '@/services/client-unit';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import ListMessages from '../UI/list-messages.vue';

@Component({
  components: { PermissionAuth, ListMessages },
})
export default class ClientUnitMulticompart extends BaseComponent {
  @Prop()
  public unit: any;

  multicompartOptions = [];
  multiMinMax = [5, 10];

  days = [];

  rules = {
    diasAntecedProd: [(v) => !v || this.validateDiasAntecedProd() || 'Não deve ser maior que antecedência de entrega'],
    diasAntecedEntr: [(v) => !v || this.validateDiasAntecedEntr() || 'Não deve ser menor que antecedência de produção'],
  };

  validateDiasAntecedEntr() {
    return (
      !this.unit.diasAntecedProdBolsaMulti ||
      Number(this.unit.diasAntecedEntrBolsaMulti) >= Number(this.unit.diasAntecedProdBolsaMulti)
    );
  }

  validateDiasAntecedProd() {
    return (
      !this.unit.diasAntecedProdBolsaMulti ||
      Number(this.unit.diasAntecedProdBolsaMulti) <= Number(this.unit.diasAntecedEntrBolsaMulti)
    );
  }

  mounted() {
    this.addSubsc(
      service.getMulticompartOptionsClientUnit().subscribe((res) => {
        this.multicompartOptions = res;
      }),
    );

    this.addSubsc(
      service.getMulticompartWeekDays().subscribe((res) => {
        this.days = res;
      }),
    );
  }

  @Watch('unit', { immediate: true })
  public onEditItemChanges(val: any) {
    this.multiMinMax = [this.unit.minBolsaMulticompart, this.unit.maxBolsaMulticompart];
    this.unit.diasEntregaBolsaMulticompart =
      this.unit.diasEntregaBolsaMulticompart && this.unit.diasEntregaBolsaMulticompart.length
        ? this.unit.diasEntregaBolsaMulticompart.map((d) => d.id)
        : [];
  }

  public onMultiMinMaxChange() {
    this.unit.minBolsaMulticompart = this.multiMinMax[0];
    this.unit.maxBolsaMulticompart = this.multiMinMax[1];
  }

  valTimeout = null;
  @Watch('unit.diasAntecedProdBolsaMulti')
  @Watch('unit.diasAntecedEntrBolsaMulti')
  private revalidateItens() {
    clearTimeout(this.valTimeout);
    this.valTimeout = setTimeout(() => {
      this.$emit('validate');
    }, 500);
  }
}
